module.exports = __webpack_public_path__ + "img/twitter_icon.3e9b9fee.svg";